import { render, staticRenderFns } from "./StatisticsFilter.vue?vue&type=template&id=394c81d4"
import script from "./StatisticsFilter.vue?vue&type=script&lang=js"
export * from "./StatisticsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports